// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'generalError.title': 'Something went wrong',
  'generalError.body':
    "We've been notified of this issue. Please hit 'Refresh' below to try again.",
  'generalError.button': 'Refresh',
};
